import { render } from "./archive.vue?vue&type=template&id=8ef51976&ts=true"
import script from "./archive.vue?vue&type=script&lang=ts"
export * from "./archive.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__